import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const [settingsOpen, setSettingsOpen] = useState(true);
  const [guestsOpen, setGuestsOpen] = useState(true);
  const [tasksOpen, setTasksOpen] = useState(true);
  const [meetingsOpen, setMeetingsOpen] = useState(true);
  const [notificationsOpen, setNotificationsOpen] = useState(true);

  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <ul className="nav sidebar-menu flex-column mb-5 pb-5">

      {/* Dashboard */}
      <li className={`nav-item ${isActive("/admin/dashboard") ? "active" : ""}`}>
        <Link to="/admin/dashboard" className="nav-link">
          <i className="nav-icon bi bi-speedometer"></i>
          <p>Dashboard</p>
        </Link>
      </li>

      {/* Guests Management */}
      <li className={`nav-item ${guestsOpen ? "menu-open" : ""}`}>
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); setGuestsOpen(!guestsOpen); }}
          className="nav-link"
        >
          <i className="nav-icon bi bi-people"></i>
          <p>
            Guests Management
            <i className={`right bi ${guestsOpen ? "bi-chevron-up" : "bi-chevron-down"} ms-2`}></i>
          </p>
        </a>

        {guestsOpen && (
          <ul className="nav nav-treeview ps-3">
            <li className={`nav-item ${isActive("/admin/guest-management/guest-intake-form") ? "active" : ""}`}>
              <Link to="/admin/guest-management/guest-intake-form" className="nav-link">
                <i className="bi bi-journal-text nav-icon"></i>
                <p>Guest Intake Form</p>
              </Link>
            </li>
            <li className={`nav-item ${isActive("/admin/guest-management/guest-intake-requests") ? "active" : ""}`}>
              <Link to="/admin/guest-management/guest-intake-requests" className="nav-link">
                <i className="bi bi-envelope-open nav-icon"></i>
                <p>Guest Intake Requests</p>
              </Link>
            </li>
            <li className={`nav-item ${isActive("/admin/guest-management/guest") ? "active" : ""}`}>
              <Link to="/admin/guest-management/guest" className="nav-link">
                <i className="bi bi-person-lines-fill nav-icon"></i>
                <p>Manage Guests</p>
              </Link>
            </li>
            <li className={`nav-item ${isActive("/admin/guest-management/reassign-bed-guest-list") ? "active" : ""}`}>
              <Link to="/admin/guest-management/reassign-bed-guest-list" className="nav-link">
<i className="bi bi-arrow-left-right nav-icon"></i>
                <p>Reassign Bed</p>
              </Link>
            </li>
            <li className={`nav-item ${isActive("/admin/guest-management/assign-roles") ? "active" : ""}`}>
              <Link to="/admin/guest-management/assign-roles" className="nav-link">
                <i className="bi bi-person-gear nav-icon"></i>
                <p>Assign Roles</p>
              </Link>
            </li>
          </ul>
        )}
      </li>

      {/* Payments */}
      <li className={`nav-item ${isActive("/admin/payments") ? "active" : ""}`}>
        <Link to="/admin/payments" className="nav-link">
          <i className="nav-icon bi bi-credit-card"></i>
          <p>Payments</p>
        </Link>
      </li>

      {/* Live Chat */}
      <li className={`nav-item ${isActive("/admin/live-chat") ? "active" : ""}`}>
        <Link to="/admin/live-chat" className="nav-link">
          <i className="nav-icon bi bi-chat-dots"></i>
          <p>Live Chat</p>
        </Link>
      </li>

      {/* Drug Screening Results */}
      <li className={`nav-item ${isActive("/admin/drug-screening-result/list") ? "active" : ""}`}>
        <Link to="/admin/drug-screening-result/list" className="nav-link">
          <i className="nav-icon bi bi-capsule-pill"></i>
          <p>Drug Screening Result</p>
        </Link>
      </li>

      {/* Form Management 
      <li className={`nav-item ${isActive("/admin/form-management/list") ? "active" : ""}`}>
        <Link to="/admin/form-management/list" className="nav-link">
          <i className="nav-icon bi bi-file-earmark-text"></i>
          <p>Form Management</p>
        </Link>
      </li>
*/}
      {/* Notifications */}
      <li className={`nav-item ${notificationsOpen ? "menu-open" : ""}`}>
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); setNotificationsOpen(!notificationsOpen); }}
          className="nav-link"
        >
          <i className="nav-icon bi bi-bell"></i>
          <p>
            App Notifications
            <i className={`right bi ${notificationsOpen ? "bi-chevron-up" : "bi-chevron-down"} ms-2`}></i>
          </p>
        </a>
        {notificationsOpen && (
          <ul className="nav nav-treeview ps-3">
            <li className={`nav-item ${isActive("/admin/notifications/send") ? "active" : ""}`}>
              <Link to="/admin/notifications/send" className="nav-link">
                <i className="bi bi-send nav-icon"></i>
                <p>Send Notifications</p>
              </Link>
            </li>
            <li className={`nav-item ${isActive("/admin/notifications/list") ? "active" : ""}`}>
              <Link to="/admin/notifications/list" className="nav-link">
                <i className="bi bi-inbox nav-icon"></i>
                <p>View Notifications</p>
              </Link>
            </li>
          </ul>
        )}
      </li>

      {/* Meetings */}
      <li className={`nav-item ${meetingsOpen ? "menu-open" : ""}`}>
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); setMeetingsOpen(!meetingsOpen); }}
          className="nav-link"
        >
          <i className="nav-icon bi bi-calendar-event"></i>
          <p>
            Meetings
            <i className={`right bi ${meetingsOpen ? "bi-chevron-up" : "bi-chevron-down"} ms-2`}></i>
          </p>
        </a>
        {meetingsOpen && (
          <ul className="nav nav-treeview ps-3">
            <li className={`nav-item ${isActive("/admin/meetings/create") ? "active" : ""}`}>
              <Link to="/admin/meetings/create" className="nav-link">
                <i className="bi bi-plus-circle nav-icon"></i>
                <p>Create Meeting</p>
              </Link>
            </li>
            <li className={`nav-item ${isActive("/admin/meetings/list") ? "active" : ""}`}>
              <Link to="/admin/meetings/list" className="nav-link">
                <i className="bi bi-list-ul nav-icon"></i>
                <p>Manage Meeting</p>
              </Link>
            </li>
          </ul>
        )}
      </li>

      {/* Tasks */}
      <li className={`nav-item ${tasksOpen ? "menu-open" : ""}`}>
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); setTasksOpen(!tasksOpen); }}
          className="nav-link"
        >
          <i className="nav-icon bi bi-list-task"></i>
          <p>
            Tasks
            <i className={`right bi ${tasksOpen ? "bi-chevron-up" : "bi-chevron-down"} ms-2`}></i>
          </p>
        </a>
        {tasksOpen && (
          <ul className="nav nav-treeview ps-3">
            <li className={`nav-item ${isActive("/admin/tasks/create") ? "active" : ""}`}>
              <Link to="/admin/tasks/create" className="nav-link">
                <i className="bi bi-plus-circle nav-icon"></i>
                <p>Create Task</p>
              </Link>
            </li>
            <li className={`nav-item ${isActive("/admin/tasks/list") ? "active" : ""}`}>
              <Link to="/admin/tasks/list" className="nav-link">
                <i className="bi bi-list-ul nav-icon"></i>
                <p>Manage Task</p>
              </Link>
            </li>
          </ul>
        )}
      </li>

      {/* Settings */}
      <li className={`nav-item ${settingsOpen ? "menu-open" : ""}`}>
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); setSettingsOpen(!settingsOpen); }}
          className="nav-link"
        >
          <i className="nav-icon bi bi-gear"></i>
          <p>
            Settings
            <i className={`right bi ${settingsOpen ? "bi-chevron-up" : "bi-chevron-down"} ms-2`}></i>
          </p>
        </a>
        {settingsOpen && (
          <ul className="nav nav-treeview ps-3">
            {[
              { to: "/admin/settings/properties", icon: "bi-building", label: "Properties" },
              { to: "/admin/settings/floors", icon: "bi-layers", label: "Floors" },
              { to: "/admin/settings/rooms", icon: "bi-door-open", label: "Rooms" },
              { to: "/admin/settings/available-beds", icon: "bi-box", label: "Available Beds" },
              { to: "/admin/settings/bed-types", icon: "bi-columns-gap", label: "Bed Types" },
              { to: "/admin/settings/beds", icon: "bi-box", label: "Beds" },
              { to: "/admin/settings/phases", icon: "bi-diagram-3", label: "Phases" },
              { to: "/admin/settings/master-tasks", icon: "bi-list-task", label: "Master Task List" },
              { to: "/admin/settings/additional-items", icon: "bi-box-seam", label: "Additional Items" },
              { to: "/admin/documents/list", icon: "bi-folder", label: "Documents" },
            ].map(({ to, icon, label }) => (
              <li key={to} className={`nav-item ${isActive(to) ? "active" : ""}`}>
                <Link to={to} className="nav-link">
                  <i className={`bi ${icon} nav-icon`}></i>
                  <p>{label}</p>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </li>
    </ul>
  );
};

export default Sidebar;
